import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';

const outlineActionButtonStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  h: BUILDER_MODE_V1_LAYOUT.actionButtonHeight,
  minH: BUILDER_MODE_V1_LAYOUT.actionButtonHeight,
  maxH: BUILDER_MODE_V1_LAYOUT.actionButtonHeight,
  px: BUILDER_MODE_V1_LAYOUT.actionButtonPaddingX,
  py: 0,
  bg: BUILDER_MODE_V1_TOKENS.white,
  border: '1px solid',
  borderColor: BUILDER_MODE_V1_TOKENS.border,
  borderRadius: BUILDER_MODE_V1_LAYOUT.actionButtonRadius,
  cursor: 'pointer',
  fontWeight: '400',
  lineHeight: 'normal',
  boxSizing: 'border-box',
  _hover: { bg: BUILDER_MODE_V1_TOKENS.activeBg },
  _active: { bg: BUILDER_MODE_V1_TOKENS.activeBg },
};

export default outlineActionButtonStyles;
